import './Layout.scss';

import Feedback from 'components/Feedback/Feedback';
// import { useFeatureFlags } from 'constants/index';
import { BreakpointContext } from 'contexts/BreakpointContext';
import useBreakPoint from 'hooks/useBreakPoint';
import React, { lazy, Suspense, useLayoutEffect, useRef } from 'react';
import { Breakpoint } from 'types/breakpoint';

import ConsentModal from './components/Modals/ConsentModal/ConsentModal';
import Header from './components/Nav/Header';
import SidebarNavigation from './components/Nav/Navigation/SidebarNavigation';

// const Chatbot = lazy(() => import("components/Chatbot"));
const SnackbarContainer = lazy(() => import("components/Snackbars/SnackbarContainer"));

const Layout = ({ children }: { children: React.ReactNode }) => {
    const isFromSmallDesktop = useBreakPoint(Breakpoint.fromSmallDesktop);
    const isUntilSmallDesktop = useBreakPoint(Breakpoint.untilSmallDesktop);
    const mobile = useBreakPoint(Breakpoint.mobile);
    const isUntilLargeMobile = useBreakPoint(Breakpoint.untilLargeMobile);
    const breakPoints = {
        mobile,
        isFromSmallDesktop,
        isUntilLargeMobile,
        isUntilSmallDesktop,
    };
    const appContentRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        // To make weleap collection page's infinite scrolling work with the hr-portal dom structure
        // So that the infinite scroller in collection page will use this element as the parent element to check if it's time to load more
        (window as any).baseInfiniteScrollParentElement = appContentRef.current;
    }, []);
    return (
        <BreakpointContext.Provider value={breakPoints}>
            <Header />
            <Suspense fallback={<div />}>
                <div className="layout">
                    <SidebarNavigation />
                    {/* {virtualAssistant && <Chatbot />} */}
                    <Feedback />
                    <div
                        ref={appContentRef}
                        className="app-content"
                    >
                        {children}
                    </div>
                </div>
                <SnackbarContainer />
            </Suspense>
            <ConsentModal />
        </BreakpointContext.Provider>
    );
};

export default Layout;
